var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: _vm.fill || "#000000",
        height: "800px",
        width: "800px",
        version: "1.1",
        id: "Layer_1",
        viewBox: "0 0 512 512",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", [
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M492.408,210.307C503.325,209.97,512,201.023,512,190.101v-77.338c0-11.164-9.051-20.216-20.216-20.216H20.216     C9.051,92.548,0,101.599,0,112.763v77.287c0,11.164,9.051,20.216,20.216,20.216c25.218,0,45.734,20.516,45.734,45.734     s-20.516,45.734-45.734,45.734C9.051,301.734,0,310.786,0,321.95v77.287c0,11.164,9.051,20.216,20.216,20.216h471.569     c11.164,0,20.216-9.051,20.216-20.216v-77.338c0-10.922-8.675-19.869-19.592-20.206c-24.836-0.767-44.29-20.837-44.29-45.693     S467.573,211.074,492.408,210.307z M162.745,379.02H40.431v-39.249c37.792-9.12,65.95-43.218,65.95-83.771     c0-40.552-28.158-74.652-65.95-83.772v-39.249h122.314V379.02z M432.049,316.025c10.997,11.315,24.617,19.251,39.521,23.217     v39.778H203.176V132.979h268.393v39.778c-14.904,3.966-28.524,11.903-39.521,23.217c-15.709,16.164-24.361,37.482-24.361,60.027     C407.686,278.544,416.339,299.861,432.049,316.025z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M372.235,198.673H246.198c-11.164,0-20.216,9.051-20.216,20.216s9.051,20.216,20.216,20.216h126.037     c11.164,0,20.216-9.051,20.216-20.216S383.399,198.673,372.235,198.673z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M372.235,272.895H246.198c-11.164,0-20.216,9.051-20.216,20.216s9.051,20.216,20.216,20.216h126.037     c11.164,0,20.216-9.051,20.216-20.216S383.399,272.895,372.235,272.895z",
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }